import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: transparent;
  box-shadow: 2px 4px 19px 1px rgba(0, 0, 0, 0.1), 0px 2px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  margin-bottom: 12px;
`

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 30px;
  align-items: center;
  height: 34px;
  background-color: ${theme.colors.neutral.high};
  padding: 0 ${theme.spacing.sm};
  border-radius: 5px 5px 0 0;
  color: ${theme.colors.neutral.white};
  font-size: ${theme.typography.sizes.xs};

  strong {
    font-family: ${theme.typography.family.bold};
  }
`

export const ContentWrapper = styled.div`
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.sm};
  border-radius: 5px;
`
